const DATABASE = 'lapathoniia-ocr-device-v1';
const STORE = 'device';

// A read-write IndexedDB transaction serializes first use across tabs. Never use
// the public browser/session IDs as this capability or send it in a URL.
export function getOcrDeviceSecret(): Promise<string> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DATABASE, 1);
    request.onupgradeneeded = () => request.result.createObjectStore(STORE);
    request.onerror = () => reject(new Error('Не вдалося відкрити захищену OCR-сесію браузера.'));
    request.onsuccess = () => {
      const database = request.result;
      let secret = '';
      const transaction = database.transaction(STORE, 'readwrite');
      const store = transaction.objectStore(STORE);
      const read = store.get('secret');
      read.onsuccess = () => {
        if (typeof read.result === 'string' && /^[a-f0-9]{64}$/.test(read.result)) {
          secret = read.result;
        } else {
          const bytes = crypto.getRandomValues(new Uint8Array(32));
          secret = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
          store.put(secret, 'secret');
        }
      };
      transaction.oncomplete = () => { database.close(); resolve(secret); };
      transaction.onabort = () => { database.close(); reject(new Error('Не вдалося зберегти захищену OCR-сесію браузера.')); };
      database.onversionchange = () => database.close();
    };
  });
}
